import { gql } from "apollo-boost";

export const FEATURED_POSTS = gql`
  query featuredPosts($postCount: Int) {
      featuredPosts(postCount: $postCount) {
          id
          chefId
          title
          blurb
          body
          isDraft
          createdAt
          updatedAt
          tags
          postSlug
          numOfLikes
          liked
          chefName
          profilePic
          media {
              type
              url
              size
              appType
          }
      }
  }
`;

export const FIND_POSTS = gql`
  query posts(
    $filters: PostInput
    $pageSize: Int
    $next: String
    $previous: String
  ) {
    posts(
      filters: $filters
      next: $next
      pageSize: $pageSize
      previous: $previous
    ) {
      posts {
        id
        chefId
        title
        blurb
        body
        isDraft
        tags
        numOfLikes
        liked
        chefName
        createdAt
        updatedAt
        postSlug
        profilePic
        media {
            type
            url
            size
            appType
        }
      }
      endCursor
      hasMore
    }
  }
`;

export const GET_POST = gql`query post($id: ID!) {
    post(id: $id) {
        id
        chefId
        chefName
        profilePic
        title
        blurb
        body
        isDraft
        tags
        numOfLikes
        liked
        postSlug
        saved
        media {
            type
            url
            size
            appType
        }
        createdAt
        updatedAt
    }
}`;

export const GET_POST_SLUG = gql`query postBySlug($slug: String!) {
    postBySlug(slug: $slug) {
        id
        chefId
        chefName
        profilePic
        title
        blurb
        body
        isDraft
        tags
        numOfLikes
        liked
        postSlug
        saved
        media {
            type
            url
            size
            appType
        }
        createdAt
        updatedAt
    }
}`;
